export class AudioCollection {
    constructor(wrapper) {
        this.wrapper = wrapper;
        this.playerBtns = [];
        this.tracks = [];
        this.isAutoplay = false;
        this.activeClass = 'is-active';
        this.autoplayClass = 'j-audio-autoplay';
    }

    init() {
        this.isAutoplay = this.wrapper.classList.contains(this.autoplayClass);
        this.playerBtns = this.wrapper.querySelectorAll('.j-stories-play');

        this.playerBtns.forEach((button) => {
            const audio = button.querySelector('audio');

            if (audio) {
                this.tracks.push({
                    button,
                    audio
                });
            }
        });

        this._bindEvents();
    }

    _bindEvents() {
        if (this.tracks.length) {
            this.tracks.forEach((track, index) => {
                track.button.addEventListener('click', () => {
                    this._controlStream(index);
                });
            });
        }

        if (this.isAutoplay) {
            this._setCollection();
        }
    }

    _controlStream(newIndexTrack) {
        if (this.tracks.length) {
            this.tracks.forEach((track, index) => {
                if (track.button.classList.contains(this.activeClass) && index !== newIndexTrack) {
                    track.audio.pause();
                    track.button.classList.remove(this.activeClass);
                }
            });
        }

        const track = this.tracks[newIndexTrack];

        if (track.button.classList.contains(this.activeClass)) {
            track.audio.pause();
        } else {
            track.audio.play();
        }

        track.button.classList.toggle(this.activeClass);
    }

    _setCollection() {
        const tracksCount = this.tracks.length;

        if (this.tracks.length > 1) {
            this.tracks.forEach((track, index) => {
                track.audio.addEventListener('ended', () => {
                    if (index === (tracksCount - 1)) {
                        track.audio.pause();
                        track.button.classList.remove(this.activeClass);
                    } else {
                        this._controlStream(index + 1);
                    }
                });
            });
        }
    }
}
